
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { Menu } from '@progress/kendo-react-layout';
import queryString from 'query-string';

import { isEmpty } from 'lodash';

import { architect, bob, k2aCore, energy, notification, schedule, service } from '../../../data/tabs';

import NavigationModal from '../Modals/NavigationModal';

import { connect } from 'react-redux';

import * as DashboardActions from '../../../actions/dashboardActions';
import * as BobActions from '../../../actions/bobActions';

import classes from './Navigation.module.css';

const Navigation = ({
    activeNavCompany,
    activeNavClient,
    activeNavEquipment,
    activeNavSite,
    companyApplications,
    companies,
    currentUser,
    fetchNavClients,
    fetchNavEquipment,
    fetchNavSystems,
    fetchNavSites,
    history,
    navClients,
    navClientsMeta,
    navEquipment,
    navEquipmentMeta,
    navSites,
    navSitesMeta,
    navSystems,
    navSystemsMeta,
    resetNavOptions,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavClient,
    setNavCompany,
    setNavEquipment,
    setNavSystem,
    setNavSite,
    targetNavClient,
    targetNavCompany,
    targetNavEquipment,
    targetNavSite,
    targetNavSystem,
    ...props
}) => {
    const [menuItems, setMenuItems] = useState([]);
    const [isShowNavModal, setNavModalOpen] = useState(false);
    const [menuType, setMenuType] = useState(null);
    const [resetType, setResetType] = useState('');

    const [tempAppId, setTempAppId] = useState(null);
    const [tempChildId, setTempChildId] = useState(null);
    const [tempParentId, setTempParentId] = useState(null);

    useEffect(() => {
        const queryValues = queryString.parse(history.location.search);
        // bob - sub menus
        let companyMenu = {
            'text':     bob.company.title,
            'appId':    bob.key,
            'parentId': bob.company.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.company.key ? classes.active : classes.menuItem
        };
        let clientMenu = {
            'text':     bob.client.title,
            'appId':    bob.key,
            'parentId': bob.client.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.client.key ? classes.active : classes.menuItem,
            'disabled': false
        };
        let siteMenu = {
            'text':     bob.site.title,
            'appId':    bob.key,
            'parentId': bob.site.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.site.key ? classes.active : classes.menuItem,
            'disabled': false
        };
        let equipmentMenu = {
            'text':     bob.equipment.title,
            'appId':    bob.key,
            'parentId': bob.equipment.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.equipment.key ? classes.active : classes.menuItem,
            'disabled': false
        };
        let systemMenu = {
            'text':     bob.system.title,
            'appId':    bob.key,
            'parentId': bob.system.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.system.key ? classes.active : classes.menuItem,
            'disabled': false
        };
        let iotHubMenu = {
            'text':     bob.iotHub.title,
            'appId':    bob.key,
            'parentId': bob.iotHub.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.iotHub.key ? classes.active : classes.menuItem,
            'disabled': false
        };
        let reportsMenu = {
            'text':     bob.reports.title,
            'appId':    bob.key,
            'parentId': bob.reports.key,
            'items':    [],
            'cssClass': queryValues.parentId === bob.reports.key ? classes.active : classes.menuItem,
            'disabled': false
        };

        bob.company.tabs.forEach(tab => {
            if (!process.env.executiveSummaryEnabled) {
                if (tab.title === 'Executive Summary') return;
            }

            companyMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.company.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.client.tabs.forEach(tab => {
            if (!process.env.contactsEnabled) {
                if (tab.title === 'Contact View') return;
            }

            clientMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.client.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.site.tabs.forEach(tab => {
            if (!process.env.contactsEnabled) {
                if (tab.title === 'Contact View') return;
            }

            siteMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.site.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.equipment.tabs.forEach(tab => {
            equipmentMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.equipment.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.system.tabs.forEach(tab => {
            systemMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.system.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.iotHub.tabs.forEach(tab => {
            iotHubMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.iotHub.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        bob.reports.tabs.forEach(tab => {
            reportsMenu.items.push({
                'text':     tab.title,
                'appId':    bob.key,
                'parentId': bob.reports.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        // first level menu
        let bobMenu = {
            'text':     bob.title,
            'appId':    bob.key,
            'cssClass': queryValues.appId === bob.key ? classes.active : classes.menuItem,
            'items':    [
                { ...companyMenu },
                { ...clientMenu },
                { ...siteMenu },
                { ...equipmentMenu },
                { ...systemMenu }
            ]
        };

        if (process.env.dashboardIothubEnabled) {
            bobMenu.items.push({ ...iotHubMenu });
        }

        // reports menu
        bobMenu.items.push({ ...reportsMenu });

        let entityMenu = {
            'text':     k2aCore.entities.title,
            'appId':    k2aCore.key,
            'parentId': k2aCore.entities.key,
            'items':    [],
            'cssClass': history.location.pathname.includes('entities') ? classes.active : classes.menuItem
        };

        let energyClientMenu = {
            'text':     energy.client.title,
            'appId':    energy.key,
            'parentId': energy.client.key,
            'items':    [],
            'cssClass': queryValues.parentId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab' ? classes.active : classes.menuItem
        };

        let energySiteMenu = {
            'text':     energy.site.title,
            'appId':    energy.key,
            'parentId': energy.site.key,
            'items':    [],
            'cssClass': queryValues.parentId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719' ? classes.active : classes.menuItem
        };

        let energyEquipmentMenu = {
            'text':     energy.equipment.title,
            'appId':    energy.key,
            'parentId': energy.equipment.key,
            'items':    [],
            'cssClass': queryValues.parentId === '16cc471d-a182-421d-bb2a-eb9560939c53' ? classes.active : classes.menuItem
        };

        energy.client.tabs.forEach(tab => {
            energyClientMenu.items.push({
                'text':     tab.title,
                'appId':    energy.key,
                'parentId': energy.client.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        energy.site.tabs.forEach(tab => {
            energySiteMenu.items.push({
                'text':     tab.title,
                'appId':    energy.key,
                'parentId': energy.site.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        energy.equipment.tabs.forEach(tab => {
            energyEquipmentMenu.items.push({
                'text':     tab.title,
                'appId':    energy.key,
                'parentId': energy.equipment.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        k2aCore.entities.tabs.forEach(tab => {
            if (tab.title === 'System') {
                if (activeNavSite.id) {
                    entityMenu.items.push({
                        'text':     tab.title,
                        'appId':    k2aCore.key,
                        'parentId': k2aCore.entities.key,
                        'childId':  tab.key,
                        'children': [],
                        'cssClass': queryValues.parentId === tab.key ? classes.active : classes.menuItem
                    });
                }
            } else {
                if (!process.env.k2aCoreExtras) {
                    if (tab.title === 'Users') return;
                }

                let children = [...tab.children];

                if (!process.env.contactsEnabled) {
                    children = children.filter(item => item.key !== 'e00237d0-659a-4cb0-94b5-ddc158b8d417' && item.key !== '2d280df7-b3fc-46ad-9e52-03437cb303f9');
                }

                children.forEach(child => {
                    child.appId = k2aCore.key;
                    child.childId = child.key;
                    child.parentId = tab.key;
                    child.cssClass = queryValues.childId === child.key ? classes.active : classes.menuItem;
                });

                entityMenu.items.push({
                    'text':     tab.title,
                    'appId':    k2aCore.key,
                    'parentId': k2aCore.entities.key,
                    'childId':  tab.key,
                    'items':    children,
                    'cssClass': queryValues.parentId === tab.key ? classes.active : classes.menuItem
                });
            }
        });


        let navMenu = {
            'text':     k2aCore.navigation.title,
            'appId':    k2aCore.key,
            'parentId': k2aCore.navigation.key,
            'items':    [],
            'cssClass': queryValues.parentId === k2aCore.navigation.key ? classes.active : classes.menuItem
        };

        k2aCore.navigation.tabs.forEach(tab => {
            navMenu.items.push({
                'text':     tab.title,
                'appId':    k2aCore.key,
                'parentId': k2aCore.navigation.key,
                'childId':  tab.key,
                'cssClass': queryValues.childId === tab.key ? classes.active : classes.menuItem
            });
        });

        let k2aCoreMenu = {
            'text':     k2aCore.title,
            'appId':    k2aCore.key,
            'cssClass': queryValues.appId === k2aCore.key ? classes.active : classes.menuItem,
            'items':    [
                { ...entityMenu }
            ]
        };

        if (process.env.k2aCoreExtras) k2aCoreMenu.items.push({ ...navMenu });

        let energyMenu = {
            'text':     energy.title,
            'appId':    energy.key,
            'cssClass': queryValues.appId === energy.key ? classes.active : classes.menuItem,
            'items':    [
                { ...energyClientMenu },
                { ...energySiteMenu },
                { ...energyEquipmentMenu }
            ]
        };

        let serviceMenu = {
            'text':     service.title,
            'appId':    service.key,
            'cssClass': queryValues.appId === service.key ? classes.active : classes.menuItem,
            'items':    []
        };

        let scheduleMenu = {
            'text':     schedule.title,
            'appId':    schedule.key,
            'cssClass': queryValues.appId === schedule.key ? classes.active : classes.menuItem,
            'items':    []
        };

        let architectMenu = {
            'text':     architect.title,
            'appId':    architect.key,
            'cssClass': queryValues.appId === architect.key ? classes.active : classes.menuItem,
            'items':    []
        };

        let notificationMenu = {
            'text':     notification.title,
            'appId':    notification.key,
            'cssClass': queryValues.appId === notification.key ? classes.active : classes.menuItem,
            'items':    []
        };

        // checking permission
        let menu = [];

        if (process.env.k2aCoreEnabled) {
            menu.push({ ...k2aCoreMenu });
        }

        menu.push({ ...bobMenu });

        if (!isEmpty(currentUser.email)) {
            if (currentUser.isSuperUser || currentUser.email.toLowerCase().includes('@key2act.com')) {
                menu.push({ ...energyMenu });
            }
        }

        if (companyApplications.includes('Service')) {
            menu.push({...serviceMenu});
        }
        if (companyApplications.includes('Schedule')) {
            menu.push({...scheduleMenu});
        }
        if (companyApplications.includes('Architect')) {
            menu.push({...architectMenu});
        }
        if (companyApplications.includes('Notification')) {
            menu.push({...notificationMenu});
        }

        setMenuItems(menu);
    }, [history.location.search, companyApplications]);

    const reset = (parentId) => {
        // company
        if (parentId === 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4' || parentId === '7e71f5d4-9fbf-4710-8601-e1f11e681479') {
            if (resetType !== 'company') {
                setResetType('company');

                resetNavOptions('client');

                setActiveNavClient({});
                setActiveNavSite({});
                setActiveNavEquipment({});

                setNavClient({});
                setNavSite({});
                setNavEquipment({});
            }
            
        // client
        } else if (parentId === 'a73c8c70-35aa-48b7-a797-4c607ae25280' || parentId === '3ee59a8f-d13a-475b-b424-ee55eef98a65' || parentId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab') {
            if (resetType !== 'client') {
                setResetType('client');
                
                resetNavOptions('site');

                setActiveNavSite({});
                setActiveNavEquipment({});

                setNavSite({});
                setNavEquipment({});
            }
        // site
        } else if (parentId === 'c0c505f5-c7fc-4317-8cb6-f6e631142a77' || parentId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b' || parentId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719') {
            if (resetType !== 'site') {
                setResetType('site');
                setActiveNavEquipment({});

                setNavEquipment({});
                setNavSystem({});
            }
        }
    };

    const onMenuSelect = (e) => {
        const { item: menu } = e;
        let path = '/v2/dashboard/company';

        if (menu.text === 'BOB' || menu.text === 'K2A Core' || menu.text === 'Entities' || menu.text === 'Notifications') {
            return;
        }

        const urlQueryValues = queryString.parse(history.location.search);
        const queryValues = {};

        queryValues.company = urlQueryValues.company;

        // set required id's from menu object to url
        queryValues.appId = menu.appId;
        queryValues.parentId = menu.parentId;
        queryValues.childId = menu.childId;

        if (menu.childId === '4b25aeb8-75d4-4522-9f77-870ab40abb07') {
            // default child view for equipment
            queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb07';
        } else if (menu.childId === '383849dd-bd20-4ee2-a0e5-1b192ddc4f81') {
            // default child view for system
            queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb02';
        } else if (menu.childId === '15dfff21-071c-4ee6-ab53-903fdcb5996a') {
            // default child view for site
            queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab20abb07';
        } else if (menu.childId === '1eb8dgee-f646-4231-8979-7ee1a715d1b4') {
            history.push({
                pathname: `/v2/dashboard/companymanagement`,
                search:   `company=${activeNavCompany.id}&isActive=true`,
                state:    { isManage: true }
            });
            return;
        } else if (menu.childId === 'c4f4919e-e301-4730-a5b8-dc1edbef6cb7') {
            setActiveNavClient({});
            setActiveNavSite({});
            setActiveNavEquipment({});
            resetNavOptions('company');
            history.push({
                pathname: `/v2/dashboard/executivesummary`,
                search:   `company=${activeNavCompany.id}`
            });
            return;
        }

        // nav modal needs these id's to update the url
        setTempAppId(menu.appId);
        setTempParentId(menu.parentId);
        setTempChildId(menu.childId);

        // render first child from menu list onclick of parent menu
        if (menu.appId === 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3') {
            if (!queryValues.childId) {
                switch (queryValues.parentId) {
                    case 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4':
                        queryValues.childId = 'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46';
                        break;
                    case 'a73c8c70-35aa-48b7-a797-4c607ae25280':
                        queryValues.childId = 'f6ba2344-ba47-42c5-a98b-978365ca3936';
                        break;
                    case 'c0c505f5-c7fc-4317-8cb6-f6e631142a77':
                        queryValues.childId = 'bb5be75b-d466-48d5-99da-79cd66504f20';
                        break;
                    case '7a88bd3d-64e3-4af9-aa06-9a31533df83c':
                        queryValues.childId = '4b25aeb8-75d4-4522-9f77-870ab40abb07';
                        // set default view child id for equipment page
                        if (!queryValues.viewChildId) {
                            queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb07';
                        }
                        break;
                    case '9f215a70-6597-482c-87a4-e515c346d7b3':
                        queryValues.childId = '383849dd-bd20-4ee2-a0e5-1b192ddc4f81';
                        // set default view child id for system page
                        if (!queryValues.viewChildId) {
                            queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb02';
                        }
                        break;
                    // set default child id for reports meno
                    case 'c49ee7b9-6a28-4820-672c-6c6a9642a4c8':
                        queryValues.childId = 'c47ee7b8-6a28-4820-937c-6c6ag642ahc8';
                        break;
                    default:
                        break;
                }
            }
        } else if (menu.appId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
            if (urlQueryValues.client) queryValues.client = urlQueryValues.client;
            if (urlQueryValues.site) queryValues.site = urlQueryValues.site;

            // delete unnecessary id's from URL
            // K2A Core Company
            if (menu.parentId === '7e71f5d4-9fbf-4710-8601-e1f11e681479') {
                if (queryValues.client) delete queryValues.client;
                if (queryValues.site) delete queryValues.site;
                // K2A Core Client
            } else if (menu.parentId === '3ee59a8f-d13a-475b-b424-ee55eef98a65') {
                if (queryValues.site) delete queryValues.site;
            }

            // Reset nav options if moving up the entity hierarchy.
            if (menu.childId === '7e71f5d4-9fbf-4710-8601-e1f11e681479' || menu.parentId === '7e71f5d4-9fbf-4710-8601-e1f11e681479') {
                reset('7e71f5d4-9fbf-4710-8601-e1f11e681479');
            } else if (menu.childId === '3ee59a8f-d13a-475b-b424-ee55eef98a65' || menu.parentId === '3ee59a8f-d13a-475b-b424-ee55eef98a65') {
                reset('3ee59a8f-d13a-475b-b424-ee55eef98a65');
            } else if (menu.childId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b' || menu.parentId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b') {
                reset('33ba6af0-1e7a-4fcf-b75b-f355a01a962b');
            }

            // Sets k2a core child when clicking on parent menu option
            if (menu.childId === '7e71f5d4-9fbf-4710-8601-e1f11e681479') {
                queryValues.parentId = '7e71f5d4-9fbf-4710-8601-e1f11e681479';
                queryValues.childId = '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48';
            } else if (menu.childId === '3ee59a8f-d13a-475b-b424-ee55eef98a65') {
                queryValues.parentId = '3ee59a8f-d13a-475b-b424-ee55eef98a65';
                queryValues.childId = 'e979b520-3695-422d-a914-ba55c51fb316';
            } else if (menu.childId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b') {
                queryValues.parentId = '33ba6af0-1e7a-4fcf-b75b-f355a01a962b';
                queryValues.childId = '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd';
            }

            setTempParentId(queryValues.parentId);
            setTempChildId(queryValues.childId);
        } else if (menu.appId === '46d93819-f375-4d5c-b117-bb374c032862') {
            //Energy Client
            if (urlQueryValues.client) queryValues.client = urlQueryValues.client;
            if (urlQueryValues.site) queryValues.site = urlQueryValues.site;

            if (menu.parentId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab') {
                if (queryValues.site) delete queryValues.site;
                if (queryValues.equipment) delete queryValues.equipment;
            } else if (menu.parentId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719') {
                if (queryValues.equipment) delete queryValues.equipment;
            }

            // Reset nav options if moving up the entity hierarchy.
            if (menu.childId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab' || menu.parentId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab') {
                resetNavOptions('site');

                setActiveNavSite({});
                setActiveNavEquipment({});

                setNavSite({});
                setNavEquipment({});
            } else if (menu.childId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719' || menu.parentId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719') {
                setActiveNavEquipment({});

                setNavEquipment({});
                setNavSystem({});
            }

            // Sets k2a core child when clicking on parent menu option
            if (menu.childId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab') {
                queryValues.parentId = '219ac5b7-d588-425d-a2ca-d2f0d92586ab';
                queryValues.childId = 'd3a45bdb-b5e7-48bf-adb3-5a469c629f20';
            } else if (menu.childId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719') {
                queryValues.parentId = 'bac0591c-03e4-4929-b71d-2f3e3d3e4719';
                queryValues.childId = '64641985-3b11-401a-b990-024d65858582';
            } else if (menu.childId === '16cc471d-a182-421d-bb2a-eb9560939c53') {
                queryValues.parentId = '16cc471d-a182-421d-bb2a-eb9560939c53';
                queryValues.childId = '4ae23613-301a-4644-b2fa-e9b3ce881e0f';
            }

            setTempParentId(queryValues.parentId);
            setTempChildId(queryValues.childId);

        } else {
            // delete parent and child id from url( on menu click except bob )
            if (queryValues.parentId) delete queryValues.parentId;
            if (queryValues.childId) delete queryValues.childId;

            if (urlQueryValues.client) queryValues.client = urlQueryValues.client;
            if (urlQueryValues.site) queryValues.site = urlQueryValues.site;
            if (urlQueryValues.equipment) queryValues.equipment = urlQueryValues.equipment;
            if (urlQueryValues.system) queryValues.system = urlQueryValues.system;

            if (menu.appId === 'c2d1468e-7e4b-4e98-95d1-72af77bf843e') {
                delete queryValues.site;
                delete queryValues.equipment;
                reset('a73c8c70-35aa-48b7-a797-4c607ae25280');

                if (activeNavSite.id || activeNavEquipment.id) {
                    path = '/v2/dashboard/client';
                } else {
                    path = history.location.pathname;
                }
            } else {
                path = history.location.pathname;
            }

            // render energy, service, schedule menu without changing the overview page.
        }

        // check required id's in url
        if (menu.parentId === 'ad356bf2-b9db-4bb5-922e-c3394b1a63e4') {
            if (isEmpty(targetNavCompany)) {
                setNavModalOpen(true);
                setMenuType('company');
                return;
            }
        } else if (menu.parentId === 'a73c8c70-35aa-48b7-a797-4c607ae25280') {
            if (isEmpty(targetNavClient)) {
                setNavModalOpen(true);
                setMenuType('client');
                return;
            } else {
                queryValues.client = targetNavClient.id;
                path = '/v2/dashboard/client';
            }
        } else if (menu.parentId === 'c0c505f5-c7fc-4317-8cb6-f6e631142a77') {
            if (isEmpty(targetNavSite)) {
                setNavModalOpen(true);
                setMenuType('site');
                return;
            } else {
                queryValues.client = targetNavClient.id;
                queryValues.site = targetNavSite.id;
                path = '/v2/dashboard/site';
            }
        } else if (menu.parentId === '7a88bd3d-64e3-4af9-aa06-9a31533df83c') {
            if (isEmpty(targetNavEquipment)) {
                setNavModalOpen(true);
                setMenuType('equipment');
                return;
            } else {
                queryValues.client = targetNavClient.id;
                queryValues.site = targetNavSite.id;
                queryValues.equipment = targetNavEquipment.id;
                path = '/v2/dashboard/equipment';
            }
        } else if (menu.parentId === '9f215a70-6597-482c-87a4-e515c346d7b3') {
            if (isEmpty(targetNavSystem)) {
                setNavModalOpen(true);
                setMenuType('system');
                return;
            } else {
                queryValues.client = targetNavClient.id;
                queryValues.site = targetNavSite.id;
                queryValues.system = targetNavSystem.id;
                path = '/v2/dashboard/system';
            }
        } else if (menu.parentId === 'c49ee7b9-6a28-4820-937c-6c6a9642a4c8') {
            path = '/v2/dashboard/iothub';
        } else if (menu.parentId === 'c49ee7b9-6a28-4820-672c-6c6a9642a4c8') {
            path = '/v2/dashboard/reports';
        } else if (menu.parentId === '46d93819-f375-4d5c-b117-bb374c032862') {
            path = '/v2/dashboard/energy';
        } else if (menu.parentId === '9d37e8b6-6ed2-4010-b0de-4a0a5a868dc1' || menu.parentId === '7e71f5d4-9fbf-4710-8601-e1f11e681479') {
            path = '/v2/dashboard/core/entities';
        } else if (menu.parentId === '219ac5b7-d588-425d-a2ca-d2f0d92586ab') {
            if (isEmpty(targetNavClient)) {
                setNavModalOpen(true);
                setMenuType('client');
                return;
            } else {
                queryValues.client = targetNavClient.id;
                path = '/v2/dashboard/energy';
            }
        } else if (menu.parentId === 'bac0591c-03e4-4929-b71d-2f3e3d3e4719') {
            if (isEmpty(targetNavSite)) {
                setNavModalOpen(true);
                setMenuType('site');
                return;
            } else {
                queryValues.site = targetNavSite.id;
                path = '/v2/dashboard/energy';
            }
        } else if (menu.parentId === '16cc471d-a182-421d-bb2a-eb9560939c53') {
            if (isEmpty(targetNavEquipment)) {
                setNavModalOpen(true);
                setMenuType('equipment');
                return;
            } else {
                queryValues.equipment = targetNavEquipment.id;
                path = '/v2/dashboard/energy';
            }
        } else if (menu.parentId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b') {
            if (isEmpty(targetNavSite)) {
                setNavModalOpen(true);
                setMenuType('site');
                return;
            } else {
                queryValues.site = targetNavSite.id;
                path = '/v2/dashboard/core/entities';
            }
        } else if (menu.parentId === '3ee59a8f-d13a-475b-b424-ee55eef98a65') {
            if (isEmpty(targetNavClient)) {
                setNavModalOpen(true);
                setMenuType('client');
                return;
            } else {
                path = '/v2/dashboard/core/entities';
            }
        } else if (menu.parentId === 'c1fe8f2d-ae8b-4555-a518-cef3c2162a03') {
            path = '/v2/dashboard/core/navigation';
        }

        if (menu.childId === '3ee59a8f-d13a-475b-b424-ee55eef98a65') {
            if (isEmpty(targetNavClient)) {
                setNavModalOpen(true);
                setMenuType('client');
                return;
            } else {
                path = '/v2/dashboard/core/entities';
            }
        } else if (menu.childId === '33ba6af0-1e7a-4fcf-b75b-f355a01a962b') {
            if (isEmpty(targetNavSite)) {
                setNavModalOpen(true);
                setMenuType('site');
                return;
            } else {
                path = '/v2/dashboard/core/entities';
            }
        }

        const queryValueString = queryString.stringify(queryValues);

        // reset entity selection
        if (menu.appId !== '46d93819-f375-4d5c-b117-bb374c032862') {
            if (queryValues.parentId) reset(queryValues.parentId);
        }

        history.push({
            pathname: path,
            search:   queryValueString,
            state:    { 'activeNavClient': activeNavClient, 'activeNavSite': activeNavSite, 'activeNavEquipment': activeNavEquipment}
        });
    };

    const closeNavSelectModal = () => {
        setNavModalOpen(false);
        setMenuType(null);
    };

    return (
        <React.Fragment>
            <Menu 
                items={menuItems}
                onSelect={onMenuSelect}
            />
            { isShowNavModal ?
                <NavigationModal
                    menuType={menuType}
                    closeNavSelectModal={closeNavSelectModal}
                    tempAppId={tempAppId}
                    tempChildId={tempChildId}
                    tempParentId={tempParentId}
                    reset={reset}
                />
                :
                null
            }
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        activeNavClient:     state.bob.activeNavClient,
        activeNavEquipment:  state.bob.activeNavEquipment,
        activeNavSite:       state.bob.activeNavSite,
        companies:           state.core.companies,
        companyApplications: state.bob.companyApplications,
        currentUser:         state.currentUser,
        navClients:          state.bob.navClients,
        navClientsMeta:      state.bob.navClientsMeta,
        navEquipment:        state.bob.navEquipment,
        navEquipmentMeta:    state.bob.navEquipmentMeta,
        navSites:            state.bob.navSites,
        navSitesMeta:        state.bob.navSitesMeta,
        navSystems:          state.bob.navSystems,
        navSystemsMeta:      state.bob.navSystemsMeta,
        targetNavClient:     state.bob.targetNavClient,
        targetNavCompany:    state.bob.targetNavCompany,
        targetNavEquipment:  state.bob.targetNavEquipment,
        targetNavSite:       state.bob.targetNavSite,
        targetNavSystem:     state.bob.targetNavSystem
    };
};

const mapDispatchToProps = {
    ...DashboardActions,
    ...BobActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation));
